import type { Color, Size, State } from "@/abc-dsk/options";

export const CLASS_NAME_COMPONENT = "tg-icon-button";

export enum Variant {
  Positive = "positive",
  Negative = "negative",
  Solid = "solid"
}

type Modifiers = {
  color?: Color;
  size?: Size;
  state?: State;
};

export const createBlockClasses = (blockName: string, { color, size, state }: Modifiers) => {
  const classes = [blockName];

  if (color) {
    classes.push(`${blockName}--${color}`);

    if (size) {
      classes.push(`${blockName}--${color}-${size}`);
    }

    if (state) {
      classes.push(`${blockName}--${color}-${state}`);
    }
  }

  if (size) {
    classes.push(`${blockName}--${size}`);

    if (state) {
      classes.push(`${blockName}--${size}-${state}`);
    }
  }

  return classes;
};
